import { combineReducers, Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import sessionStorage from 'redux-persist/lib/storage/session';

export default (reducers: Reducer) => {
  const sessionReducer = persistReducer(
    {
      key: 'boletimWeb',
      storage: sessionStorage,
      whitelist: [
        'notification',
        'new_notification',
        'flash_messages_notification',
        'undoToast',
        'panel',
        'onlineSearch',
        'followupOnlineSearch',
        'biddings',
        'followups',
        'atas',
        'plans',
        'additionalServices',
        'parcelasCondicoes',
        'selectedPlan',
        'simulate',
        'update_sale',
        'create_sale',
        'management',
        'simulate_all',
        'parcelamento',
        'proportional_sale',
        'get_imminence',
        'contracts',
        'my_history',
        'documents',
        'bulletins',
        'my_account',
        'course',
        'market',
        'tools_status',
        'juridico',
        'chatbot_assistant',
        'dica_legal',
        'campaign_simulation',
        'dr_licita',
        'portals_manager',
        'bidding_summary',
        'conlicitaseg',
        'register',
        'contract_analysis',
        'central_ia',
      ],
      version: parseInt(process.env.REACT_APP_STORE_VERSION || '0', 10),
      migrate: (state) => {
        return Promise.resolve(state);
      },
    },
    reducers,
  );

  const storageReducer = persistReducer(
    {
      key: 'boletimWeb',
      storage,
      whitelist: [
        'profile',
        'monitoring',
        'userPreferences',
        'monitoringPreferences',
        'servicesSubscriptions',
        'userContacts',
        'activities',
      ],
      version: parseInt(process.env.REACT_APP_STORE_VERSION || '0', 10),
      migrate: (state) => {
        return Promise.resolve(state);
      },
    },
    reducers,
  );

  return combineReducers({ session: sessionReducer, storage: storageReducer });
};
